export default {
    eventItems:      { method: 'get',    url: 'event_items' },
    createEventItem: { method: 'post',   url: 'event_items'},
    updateEventItem: { method: 'put',    url: 'event_items/{id}'},
    deleteEventItem: { method: 'delete', url: 'event_items/{id}'}
}